import { computed, Directive, ElementRef, inject, ViewChild } from '@angular/core';
import { LayoutService } from '@app/layout/service/layout.service';

@Directive()
export abstract class BaseSidebar {
  public readonly layoutService = inject(LayoutService);

  timeout: ReturnType<typeof setTimeout> | null = null;

  isHorizontal = computed(() => this.layoutService.isHorizontal());

  @ViewChild('menuContainer') menuContainer!: ElementRef;

  onMouseEnter(): void {
    if (!this.layoutService.layoutState().anchored) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.layoutService.layoutState.update((state) => {
        if (!state.sidebarActive) {
          return {
            ...state,
            sidebarActive: true,
          };
        }
        return state;
      });
    }
  }

  onMouseLeave(): void {
    if (!this.layoutService.layoutState().anchored) {
      if (!this.timeout) {
        this.timeout = setTimeout(() => {
          this.layoutService.layoutState.update((state) => {
            if (state.sidebarActive) {
              return {
                ...state,
                sidebarActive: false,
              };
            }
            return state;
          });
        }, 300);
      }
    }
  }

  /**
   * Cierra el menú. En móvil se abre sobre el contenido y el botón de la topbar
   * queda tapado por el propio menú, así que necesita su propio cierre.
   */
  closeMenu(): void {
    this.layoutService.requestMenuClose();
  }

  anchor(): void {
    this.layoutService.layoutState.update((state) => ({
      ...state,
      anchored: !state.anchored,
    }));
  }
}
